var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 33,
    viewBox: "0 0 76 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-194 -67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(220 67)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.952,4.1a3,3,0,0,1,5.1,0l15.1,24.315A3,3,0,0,1,35.6,33H5.4a3,3,0,0,1-2.548-4.583Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.4999942779541 7.580295562744141 L 7.193817138671875 28.99999618530273 L 33.80617904663086 28.99999618530273 L 20.4999942779541 7.580295562744141 M 20.49999618530273 2.685230255126953 C 21.48074913024902 2.685230255126953 22.46150207519531 3.157546997070313 23.0483226776123 4.102176666259766 L 38.15295028686523 28.41694641113281 C 39.39440155029297 30.41537666320801 37.95726013183594 32.99999618530273 35.60463333129883 32.99999618530273 L 5.395370483398438 32.99999618530273 C 3.042732238769531 32.99999618530273 1.605602264404297 30.41537666320801 2.847042083740234 28.41694641113281 L 17.9516716003418 4.102176666259766 C 18.53849220275879 3.157546997070313 19.51924514770508 2.685230255126953 20.49999618530273 2.685230255126953 Z",
    stroke: "none",
    fill: "#fe4400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    transform: "translate(194 67)",
    fill: "none",
    stroke: "#ff9a75",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 33,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 29,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(263 93)",
    fill: "#ffbca4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f2bc7af7cda622a5d43d78cbec1a169.svg";
export { ForwardRef as ReactComponent };